import { REHYDRATE } from "redux-persist";
import update from "immutability-helper";
import {
    updatedObject,
    addNestedFields,
    removeNestedFields,
    ANY_FIELD_UPDATE,
    ANY_FIELD_ADD,
    ANY_FIELD_REMOVE,
} from "actions/formActions";
import { LOGOUT } from "actions/loginStateActions";
import {
    ADMIN_INSPECTION_LIST_INIT,
    ADMIN_INSPECTION_FILTERS_APPLY,
    ADMIN_INSPECTION_LIST_FETCH_BEGIN,
    ADMIN_INSPECTION_LIST_FETCH_SUCCESS,
    ADMIN_INSPECTION_LIST_FETCH_FAIL,
    ADMIN_INSPECTION_LIST_FETCH_WITH_FILTERS_BEGIN,
    ADMIN_INSPECTION_LIST_FETCH_WITH_FILTERS_SUCCESS,
    ADMIN_INSPECTION_LIST_FETCH_WITH_FILTERS_FAIL,
    ADMIN_INSPECTION_FILTERS_RESET,
    ADMIN_INSPECTION_LIST_RESET,
} from "./types";
import INITIAL_STATE from "./state";

export default function adminInspectionListReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case REHYDRATE:
            return state;

        case ADMIN_INSPECTION_LIST_INIT:
            return { ...INITIAL_STATE, status: "editing" };

        case ADMIN_INSPECTION_FILTERS_APPLY:
            return update(state, { data: { filters: { $set: action.filters } } });

        // *******************************
        //        JOB FETCH
        // *******************************
        case ADMIN_INSPECTION_LIST_FETCH_BEGIN:
            return { ...state, status: "fetching" };

        case ADMIN_INSPECTION_LIST_FETCH_SUCCESS:
            return update(state, {
                data: { jobs: { $set: action.data } },
                status: { $set: "success" },
            });

        case ADMIN_INSPECTION_LIST_FETCH_FAIL:
            return { ...state, status: "fail", reason: action.reason };

        case ADMIN_INSPECTION_LIST_FETCH_WITH_FILTERS_BEGIN:
            return { ...state, status: "applying" };

        case ADMIN_INSPECTION_LIST_FETCH_WITH_FILTERS_SUCCESS:
            return update(state, {
                data: { jobs: { $set: action.data } },
                status: { $set: "success" },
            });

        case ADMIN_INSPECTION_LIST_FETCH_WITH_FILTERS_FAIL:
            return { ...state, status: "failed", reason: action.reason };

        case ANY_FIELD_UPDATE: {
            if (action.storeName !== "adminInspectionList") return state;

            return {
                ...state,
                data: updatedObject(state.data, action.accessPath, action.newVal),
                isChanged: true,
            };
        }

        case ANY_FIELD_ADD: {
            if (action.storeName !== "adminInspectionList") return state;

            return {
                ...state,
                data: addNestedFields(state.data, action.accessPath, action.newObj),
                isChanged: true,
            };
        }

        case ANY_FIELD_REMOVE: {
            if (action.storeName !== "adminInspectionList") return state;

            return {
                ...state,
                data: removeNestedFields(state.data, action.accessPath),
                isChanged: true,
            };
        }

        case ADMIN_INSPECTION_FILTERS_RESET:
            return update(state, {
                data: {
                    searchKeyword: { $set: INITIAL_STATE.data.searchKeyword },
                    filters: { $set: INITIAL_STATE.data.filters },
                },
            });

        case ADMIN_INSPECTION_LIST_RESET:
            return INITIAL_STATE;

        case LOGOUT:
            return INITIAL_STATE;

        default:
            return state;
    }
}
